import {createContext} from 'react';

import {ReviewsStateContextType} from './reviews-state-type';

export const ReviewsStateContext = createContext<ReviewsStateContextType | null>(null);
